import { watch, computed } from 'vue';
import { useStorage } from '@vueuse/core';
import { useTheme } from 'vuetify';

import { ThemeName } from '@/types/theme';

export function useAppTheme() {
  const vTheme = useTheme();

  const storedTheme = useStorage<ThemeName>('app-theme', ThemeName.light);

  watch(
    storedTheme,
    (theme: ThemeName) => {
      vTheme.change(theme);

      // Update the document root for scrollbars and CSS variables
      document.documentElement.setAttribute('data-theme', theme);

      // Explicitly tell the browser the color scheme
      document.documentElement.style.colorScheme = theme;
    },
    { immediate: true }
  );

  const isDarkMode = computed<boolean>({
    get: () => storedTheme.value === ThemeName.dark,
    set: (isDark: boolean) => {
      storedTheme.value = isDark ? ThemeName.dark : ThemeName.light;
    }
  });

  return {
    isDarkMode
  };
}
